import { assoc, assocPath, dissocPath, path } from 'ramda'
import { LandscapeState } from 'vms-state'
import def from './define-action'

const INITIAL_STATE = {
    uuids               : {},
    savingBulkEdits     : false,
    configuringBulkEdits: false,
    selectAll           : false,
}

// =====================================================================================================================
// Action Constants
// =====================================================================================================================

const ActionConstants = {
    BULK_EDIT_POI          : 'BULK_EDIT_POI',
    BULK_EDIT_POI_LIST     : 'BULK_EDIT_POI_LIST',
    BULK_SAVE_COMPLETE     : 'BULK_SAVE_COMPLETE',
    BULK_SAVE_FAILURE      : 'BULK_SAVE_FAILURE',
    CANCEL_BULK_EDITS      : 'CANCEL_BULK_EDITS',
    CONFIGURING_BULK_EDITS : 'CONFIGURING_BULK_EDITS',
    DONT_BULK_EDIT_POI     : 'DONT_BULK_EDIT_POI',
    SAVING_BULK_EDITS      : 'SAVING_BULK_EDITS',
    SELECT_ALL             : 'SELECT_ALL',
}

// =====================================================================================================================
// Actions
// =====================================================================================================================

const Actions = {
    bulkEditPoi          : def(ActionConstants.BULK_EDIT_POI, 'poiId'),
    bulkEditPoiList      : def(ActionConstants.BULK_EDIT_POI_LIST, 'poisSelected'),
    bulkSaveComplete     : def(ActionConstants.BULK_SAVE_COMPLETE),
    bulkSaveFailure      : def(ActionConstants.BULK_SAVE_FAILURE),
    cancelBulkEdits      : def(ActionConstants.CANCEL_BULK_EDITS),
    configuringBulkEdits : def(ActionConstants.CONFIGURING_BULK_EDITS),
    dontBulkEditPoi      : def(ActionConstants.DONT_BULK_EDIT_POI, 'poiId'),
    savingBulkEdits      : def(ActionConstants.SAVING_BULK_EDITS),
    selectAll            : def(ActionConstants.SELECT_ALL),
}

// =====================================================================================================================
// Reducer
// =====================================================================================================================

const reducer = (state = INITIAL_STATE, action) => {
    const VENUE_LOADING_STARTED = LandscapeState.actions.VENUE_LOADING_STARTED

    switch (action.type) {
    case ActionConstants.BULK_EDIT_POI          : return assocPath(['uuids', action.poiId], true, state)
    case ActionConstants.BULK_EDIT_POI_LIST     : return assoc('uuids', action.poisSelected, state)
    case ActionConstants.BULK_SAVE_COMPLETE     : return { savingBulkEdits: false, uuids: {}, configuringBulkEdits: false }
    case ActionConstants.BULK_SAVE_FAILURE      : return assoc('savingBulkEdits', false, state)
    case ActionConstants.CANCEL_BULK_EDITS      : return { ...INITIAL_STATE }
    case ActionConstants.CONFIGURING_BULK_EDITS : return assoc('configuringBulkEdits', true, state)
    case ActionConstants.DONT_BULK_EDIT_POI     : return dissocPath(['uuids', action.poiId], state)
    case ActionConstants.SAVING_BULK_EDITS      : return assoc('savingBulkEdits', true, state)
    case ActionConstants.SELECT_ALL             : return assoc('selectAll', !state.selectAll, state)
    case VENUE_LOADING_STARTED          : return assoc('uuids', {}, state)
    default                             : return state
    }
}

// =====================================================================================================================
// Selectors
// =====================================================================================================================

const getBulkEditIds         = state => path(['bulkEdits', 'uuids'],                state)
const isConfiguringBulkEdits = state => path(['bulkEdits', 'configuringBulkEdits'], state)
const isSavingBulkEdits      = state => path(['bulkEdits', 'savingBulkEdits'],      state)
const isAllSelected          = state => path(['bulkEdits', 'selectAll'],            state)

const Selectors = {
    getBulkEditIds,
    isConfiguringBulkEdits,
    isSavingBulkEdits,
    isAllSelected,
}

export default reducer


export {
    reducer,
    Actions,
    Selectors,
}


